import { Component, OnInit, Input } from '@angular/core';
import { NgxChartsModule, ColorHelper } from '@swimlane/ngx-charts';

@Component({
  selector: 'pie-stats',
  templateUrl: './pie.component.html',
  styleUrls: ['./pie.component.css'],
})
export class PieComponent implements OnInit {
  @Input() data;

  // options
  gradient: boolean = false;
  showLegend: boolean = true;
  legendTitle: string = '';
  isDoughnut: boolean = false;
  legendPosition: string = 'right';
  public activeEntries: any[] = [];
  public chartNames: string[];
  public colorScheme = {
    domain: ['#CB4728', '#6040B1', '#16B96A', '#F29D39', '#3E67C5', '#6FCF97', '#F2C94C']
  };
  public colors: ColorHelper;
  

  constructor() {}

  ngOnInit() {
    this.chartNames = this.data.answers.map((d: any) => d.name);
        // Convert hex colors to ColorHelper for consumption by legend
    this.colors = new ColorHelper(this.colorScheme, 'ordinal', this.chartNames, this.colorScheme);
  }

  public legendLabelActivate(item: any): void {
    this.activeEntries = [item];
  } 

  public legendLabelDeactivate(item: any): void {
    this.activeEntries = [];
  }
  

}
